import { TimePicker, TimePickerProps } from "antd";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import { Link, useParams } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";
import { useCreateClientVisitDetailsMutation, useGetProjectLookupsQuery, useUpdateClientVisitDetailsMutation } from "../../../../../services/EndPointsApis";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { svgIcons } from "../../../../../style/fonts/SvgIcons";
import * as Yup from "yup";
import dayjs, { Dayjs } from "dayjs";

const ClientVisitSidebar = ({ setSelectedIndividualCheckboxId, setSelectedItemData, setIsTableHeadChecked, projectLookups, activityTogglePopup, closeSidebar, isEditing, isViewOnly, clientVisitsData, refetch }: any) => {

    dayjs.extend(customParseFormat);
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    const [createClientVisits, { data: createClientVisitsData, isLoading, isSuccess, isError, error }] = useCreateClientVisitDetailsMutation()
    const [updateClientVisits, { data: updateClientVisitsData, isLoading: updateClientVisitsIsLoading, isSuccess: updateClientVisitsIsSuccess, isError: updateClientVisitsIsError, error: updateClientVisitsError }] = useUpdateClientVisitDetailsMutation()

    const { projectId } = useParams();

    const clientVisitSchema = Yup.object().shape({
        lst_VisitType: Yup.object({
            id: Yup.number().required('Visit Type is required'),
        }).required(),
        lst_VisitLocation: Yup.object({
            id: Yup.number().required('Visit Location is required'),
        }).required(),
        scheduledDate: Yup.string().required("Date is required"),
        scheduledTime: Yup.string().required("Start Time is required"),
        scheduleEndTime: Yup.string().required("End Time is required"),
        lst_OutComeOfVisit: Yup.object({
            id: Yup.number().required('OutCome Of Visit is required'),
        }).required(),
        lst_PriceRangeStart: Yup.object()
            .nullable()
            .shape({
                id: Yup.number(),
                value: Yup.string(),
            })
            .test(
                'price-range-start-validation',
                'Price Range Start should be smaller than Price Range End',
                function (value, context) {
                    const { lst_PriceRangeEnd } = context.parent;
                    if (!value?.id || !lst_PriceRangeEnd?.id) {
                        return true;
                    }
                    return value.id < lst_PriceRangeEnd.id;
                }
            ),
        lst_PriceRangeEnd: Yup.object()
            .nullable()
            .shape({
                id: Yup.number(),
                value: Yup.string(),
            })
            .test(
                'price-range-end-validation',
                'Price Range End should be greater than Price Range Start',
                function (value, context) {
                    const { lst_PriceRangeStart } = context.parent;
                    if (!value?.id || !lst_PriceRangeStart?.id) {
                        return true; // Skip validation if one of the fields is empty
                    }
                    return value.id > lst_PriceRangeStart.id;
                }
            ),
    });


    const initialValues = {
        projectId: projectId,
        clientVisitId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        lst_VisitType: {
            id: 0,
            value: ''
        },
        lst_VisitLocation: {
            id: 0,
            value: ''
        },
        lst_OutComeOfVisit: {
            id: 0,
            value: ''
        },
        lst_PriceRangeStart: {
            id: 0,
            value: ''
        },
        lst_PriceRangeEnd: {
            id: 0,
            value: ''
        },
        isConfirmed: true,
        notes: [
            {
                noteId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                visitMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                note: '',
                createdBy: '',
                createdById: 0,
                createdDate: new Date().toISOString()
            }
        ],
        scheduledDate: '',
        scheduledTime: '',
        scheduleEndTime: '',
        recordNumber: ''
    }
    const [updateId, setUpdateId] = useState(0);
    const [formValues, setFormValues] = useState(initialValues);
    // Store form values when the modal is closed
    const handleModalClose = () => {
        setFormValues(formik.values);
        closeSidebar();
        resetForm()
    };
    useEffect(() => {
        // Restore form values when the modal reopens
        if (activityTogglePopup && !clientVisitsData && Object.keys(formValues).length !== 0) {
            formik.setValues(formValues);
        }
        // Update form values based on clientVisitsData received
        if (clientVisitsData) {
            setUpdateId(clientVisitsData?.clientVisitId);
            formik.setValues({ ...clientVisitsData });
        } else if (!activityTogglePopup) {
            // Reset form values only when closing and it's not an update action
            setUpdateId(0);
            formik.resetForm();
        }
    }, [activityTogglePopup, clientVisitsData]);





    const formik = useFormik({
        validationSchema: clientVisitSchema,
        initialValues,
        onSubmit: (values, { resetForm }) => {
            // createClientVisits(values)
            if (updateId) {
                updateClientVisits(values)
            } else {
                createClientVisits({ ...values, projectId: projectId })
            }
        }
    })

    const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('scheduledTime', formattedTime);
    };
    const onChangeEnd: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('scheduleEndTime', formattedTime);
    };
    const [selectedStartDate, setSelectedStartDate] = useState<null>(null);

    const handleStartDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('scheduledDate', date ? date.format('YYYY-MM-DD') : null);
        formik.setFieldTouched('scheduledDate', true, false);
    };
    const { resetForm } = formik;

    useEffect(() => {
        if (isSuccess) {
            toast.success(createClientVisitsData?.message);
            resetForm()
            handleModalClose()
            refetch()
        }
    }, [isSuccess]);
    useEffect(() => {
        if (updateClientVisitsIsSuccess) {
            toast.success(updateClientVisitsData?.message);
            handleModalClose()
            refetch()
            resetForm()
            setSelectedIndividualCheckboxId([])
            setIsTableHeadChecked(false)
            setSelectedItemData({})
        }
    }, [updateClientVisitsIsSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
            resetForm()
        }

    },
        [updateClientVisitsIsError]);

    useEffect(() => {
        if (updateClientVisitsIsError && updateClientVisitsError) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in updateClientVisitsError && updateClientVisitsError.data && typeof updateClientVisitsError.data === 'object' && 'message' in updateClientVisitsError.data) {
                errorMessage = (updateClientVisitsError.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [updateClientVisitsError]);

    // Ensure the initial note is displayed
    useEffect(() => {
        if (!formik.values.notes || formik.values.notes.length === 0) {
            formik.setFieldValue('notes', [
                {
                    noteId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    visitMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    note: '', // add at least one default note
                    createdBy: '',
                    createdById: 0,
                    createdDate: new Date().toISOString()
                }
            ]);
        }
    }, [formik]);

    const handleSubmit = () => {
        formik.handleSubmit()
    }

    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className="sidebar-header">
                    <h4>{isEditing ? "Edit Client Visit" : isViewOnly ? "Client Visit" : "Add Client Visit"} </h4>
                    <Link to="#" className="sidebar-close toggle-btn" onClick={handleModalClose}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                {/* <form onSubmit={formik.handleSubmit}> */}
                <div className="toggle-body">
                    <div className="toggle-height">
                        <div className="pro-create">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-wrap">
                                            <label className="col-form-label">
                                                Visit Type <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={projectLookups?.result?.Lst_VisitType?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values.lst_VisitType?.id
                                                        ? {
                                                            value: formik.values.lst_VisitType?.id,
                                                            label: formik.values.lst_VisitType?.value || '',
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue(`lst_VisitType.id`, selectedOption?.value || null);
                                                    formik.setFieldValue(`lst_VisitType.value`, selectedOption?.label || null);
                                                }}
                                                isDisabled={isViewOnly}
                                            />
                                            {formik.submitCount > 0 && formik.errors.lst_VisitType?.id && (
                                                <div className="error">{formik.errors.lst_VisitType.id}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className="col-form-label">
                                                Scheduled Date<span className="text-danger"> *</span>
                                            </label>
                                            <DatePicker
                                                className="form-control datetimepicker deals-details "
                                                // selected={selectedFreshAptmentDate}
                                                onChange={handleStartDateChange}
                                                value={formik.values?.scheduledDate ? dayjs(formik.values?.scheduledDate, 'YYYY-MM-DD') : null}
                                                format="MMM-DD-YYYY"
                                                disabled={isViewOnly}
                                            />
                                            {formik.submitCount > 0 && formik.errors.scheduledDate && (
                                                <div className="error">{formik.errors.scheduledDate}</div>
                                            )}
                                        </div>
                                        <div className="col-md-3">
                                            <label className="col-form-label">
                                                Start Time <span className="text-danger"> *</span>
                                            </label>
                                            <TimePicker
                                                placeholder="Select Time"
                                                className="form-control datetimepicker-time"
                                                onChange={onChangeStart}
                                                format="h:mm A"
                                                use12Hours
                                                disabled={isViewOnly}
                                                value={formik.values.scheduledTime ? dayjs(formik.values.scheduledTime, "h:mm A") : null} // Controlled value

                                            />
                                            {formik.submitCount > 0 && formik.errors.scheduledTime && (
                                                <div className="error">{formik.errors.scheduledTime}</div>
                                            )}
                                        </div>

                                        <div className="col-md-3">
                                            <label className="col-form-label">
                                                End Time <span className="text-danger"> *</span>
                                            </label>
                                            <TimePicker
                                                placeholder="Select Time"
                                                className="form-control datetimepicker-time"
                                                onChange={onChangeEnd}
                                                format="h:mm A"
                                                use12Hours
                                                disabled={isViewOnly}
                                                value={formik.values.scheduleEndTime ? dayjs(formik.values.scheduleEndTime, "h:mm A") : null} // Controlled value

                                            />
                                            {formik.submitCount > 0 && formik.errors.scheduleEndTime && (
                                                <div className="error">{formik.errors.scheduleEndTime}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label className="col-form-label">
                                            Visit Location<span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            options={projectLookups?.result?.Lst_VisitLocation?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            }))}
                                            value={
                                                formik.values.lst_VisitLocation?.id
                                                    ? {
                                                        value: formik.values.lst_VisitLocation?.id,
                                                        label: formik.values.lst_VisitLocation?.value || '',
                                                    }
                                                    : null
                                            }
                                            onChange={(selectedOption: any) => {
                                                formik.setFieldValue(`lst_VisitLocation.id`, selectedOption?.value || null);
                                                formik.setFieldValue(`lst_VisitLocation.value`, selectedOption?.label || null);
                                            }}
                                            isDisabled={isViewOnly}
                                        />
                                        {formik.errors.lst_VisitLocation?.id && formik.submitCount > 0 && (
                                            <div className="error">{formik.errors.lst_VisitLocation.id}</div>
                                        )}

                                    </div>
                                    <div className="col-md-4 mt-2">
                                        <label className="col-form-label">
                                            Confirmed?
                                        </label>
                                        <label className="checkboxs mt-3">
                                            <input
                                                type="checkbox"
                                                checked={formik?.values?.isConfirmed}
                                                {...formik.getFieldProps('isConfirmed')}
                                                disabled={isViewOnly}
                                            />
                                            <span className="checkmarks" />
                                        </label>
                                    </div>
                                    <div className="col-md-8 mt-2">
                                        <label className="col-form-label">
                                            Outcome Of Visit<span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            options={projectLookups?.result?.Lst_OutComeOfVisit?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            }))}
                                            value={
                                                formik.values.lst_OutComeOfVisit?.id
                                                    ? {
                                                        value: formik.values.lst_OutComeOfVisit?.id,
                                                        label: formik.values.lst_OutComeOfVisit?.value || '',
                                                    }
                                                    : null
                                            }
                                            onChange={(selectedOption: any) => {
                                                formik.setFieldValue(`lst_OutComeOfVisit.id`, selectedOption?.value || null);
                                                formik.setFieldValue(`lst_OutComeOfVisit.value`, selectedOption?.label || null);
                                            }}
                                            isDisabled={isViewOnly}
                                        />
                                        {formik.errors.lst_OutComeOfVisit?.id && formik.submitCount > 0 && (
                                            <div className="error">{formik.errors.lst_OutComeOfVisit.id}</div>
                                        )}
                                    </div>

                                    <div className='d-flex align-items-center'>
                                        <div className="col-md-5 mt-2">
                                            <label className="col-form-label">
                                                Price Range
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={projectLookups?.result?.Lst_PriceRange?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values.lst_PriceRangeStart?.id
                                                        ? {
                                                            value: formik.values.lst_PriceRangeStart?.id,
                                                            label: formik.values.lst_PriceRangeStart?.value || '',
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue(`lst_PriceRangeStart.id`, selectedOption?.value || null);
                                                    formik.setFieldValue(`lst_PriceRangeStart.value`, selectedOption?.label || null);
                                                }}
                                                isDisabled={isViewOnly}
                                            />
                                            {formik.errors.lst_PriceRangeStart && typeof formik.errors.lst_PriceRangeStart === 'string' && (
                                                <div className="error">{formik.errors.lst_PriceRangeStart}</div>
                                            )}
                                        </div>


                                        <div className='col-md-2 d-flex justify-content-center'> <hr className='mt-5' style={{ borderWidth: '3px', width: "20px" }} /></div>

                                        <div className="col-md-5 mt-2">
                                            <label className="col-form-label">
                                                <span className="text-danger"> </span>
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={projectLookups?.result?.Lst_PriceRange?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values.lst_PriceRangeEnd?.id
                                                        ? {
                                                            value: formik.values.lst_PriceRangeEnd?.id,
                                                            label: formik.values.lst_PriceRangeEnd?.value || '',
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue(`lst_PriceRangeEnd.id`, selectedOption?.value || null);
                                                    formik.setFieldValue(`lst_PriceRangeEnd.value`, selectedOption?.label || null);
                                                }}
                                                isDisabled={isViewOnly}
                                            />
                                            {formik.errors.lst_PriceRangeEnd && typeof formik.errors.lst_PriceRangeEnd === 'string' && (
                                                <div className="error">{formik.errors.lst_PriceRangeEnd}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-12 mt-2">

                                        <div className="form-wrap">

                                            <div className='d-flex justify-content-between w-100'>
                                                <label className="col-form-label">
                                                    Note
                                                </label>
                                                {!isViewOnly &&
                                                    <button
                                                        type="button"
                                                        className='btn btn-sm text-primary ps-0 pe-10'
                                                        onClick={() => {
                                                            const currentNotesItems = Array.isArray(formik.values.notes)
                                                                ? formik.values.notes
                                                                : []; // Ensure it's an array

                                                            formik.setFieldValue('notes', [
                                                                ...currentNotesItems,
                                                                {
                                                                    noteId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                                                                    visitMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                                                                    note: '',
                                                                    createdBy: '',
                                                                    createdById: 0,
                                                                    createdDate: new Date().toISOString()
                                                                }
                                                            ]);
                                                        }}
                                                    >
                                                        Add More
                                                    </button>
                                                }
                                            </div>
                                            {formik.values?.notes?.map((item: any, index: any) => (
                                                <div className="position-relative">
                                                    <textarea
                                                        key={index}
                                                        className="form-control mb-3"
                                                        rows={4}
                                                        placeholder='Type....'
                                                        {...formik.getFieldProps(`notes[${index}].note`)}
                                                        value={item.note || ''}
                                                        disabled={isViewOnly}
                                                    />

                                                    {index > 0 && (
                                                        <button
                                                            className="position-absolute top-0 m-2 cursor-pointer btn-transparent border border-0"
                                                            style={{ right: 0, fill: '#dc3545' }}

                                                            onClick={() => {
                                                                const updatedNotesItems = formik.values.notes.filter((_: any, i: any) => i !== index);
                                                                formik.setFieldValue('notes', updatedNotesItems);

                                                            }}
                                                            disabled={isViewOnly}
                                                        >
                                                            {svgIcons.deleteIcon}
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="submit-button text-end">

                            <Link to="#" className="btn btn-light sidebar-close" onClick={handleModalClose}>
                                Cancel
                            </Link>

                            {!isViewOnly ?
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                >
                                    {isLoading || updateClientVisitsIsLoading ? 'Loading...' :
                                        <>
                                            {isEditing ? "Update" : "Add"}
                                        </>}
                                </button> :
                                ''}
                        </div>
                    </div>
                </div>
                {/* </form> */}
            </div>
        </div>
    );
};

export default ClientVisitSidebar;
